export const IMPORT_EXPORT_HISTORIES_PER_PAGE = 50;
export const POLL_INTERVAL_MS = 5000;
export const MAX_POLLING_DURATION_MS = 300_000; // 5 minutes
export const MAX_RETRIES = 5;
